module.exports = __webpack_public_path__ + "static/media/stm-21st-desktop-2440x300-@2x.7fd5da65.webp";